import { useEffect, useState } from 'react';
import { GetToken } from 'components/util/Helpers/Auth';
import { getFamilias as getFamilies } from 'controllers/qualidade';

interface IFamily {
  cd_familia: number;
  nm_familia: string;
}

interface IUseFamilies {
  cdGrupo: number;
  cdDiv: number;
  areFamilyFiltersActive?: boolean;
}

const shapeFamilies = (families: IFamily[]) => {
  families.unshift({
    cd_familia: 0,
    nm_familia: 'Selecione uma família'
  });
  return families.sort(sortFamiliesByCd);
};

const sortFamiliesByCd = (a: IFamily, b: IFamily) => {
  if (a.cd_familia < b.cd_familia) {
    return -1;
  }
  if (a.cd_familia > b.cd_familia) {
    return 1;
  }
  return 0;
};

const fetchFamilies = async ({ cdGrupo, cdDiv }: IUseFamilies) => {
  return getFamilies({ token: GetToken(), params: { cdGrupo, cdDiv } })
    .then((res) => JSON.parse(res.body))
    .then((families) => shapeFamilies(families));
};

export const useFamiliesFilters = ({ cdGrupo, cdDiv, areFamilyFiltersActive }: IUseFamilies) => {
  const [families, setFamilies] = useState([] as IFamily[]);

  useEffect(() => {
    const fetchData = async () => {
      const families = await fetchFamilies({ cdGrupo, cdDiv });
      setFamilies(families);
    };

    if (areFamilyFiltersActive) {
      fetchData();
    }
  }, [cdGrupo, cdDiv]);

  return { families };
};
